import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { post, patch } from '../core/http';
import { API } from '../core/constants';
import { docId } from '../core/Firebase';
import Modal from './ui/Modal';

const CategoryForm = ({ category, onFormSubmit, onCancel }) => {
  const [id, setId] = useState('');

  useEffect(() => {
    if (!category?.id) {
      setId(docId());
    } else {
      setId(category.id);
    }
  }, [category]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: category,
  });

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      id,
    };

    try {
      let result;
      if (category?.id) {
        result = await patch(`${API}/categories/${id}`).send(payload);
        if (result.body) {
          console.log(result.body);
        }
      } else {
        result = await post(`${API}/categories`).send(payload);
      }

      onFormSubmit(result.body);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal title={category ? category.title : 'Add new category'} onClose={onCancel}>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-3">
        <label className="block">
          <span className="label-text text-xs font-semibold">Title</span>
          <input
            className="input input-bordered input-sm w-full mt-1"
            {...register('title', { required: 'Title is required' })}
            placeholder="Title"
          />
          {errors.title && <p className="text-error text-xs mt-1">{errors.title.message}</p>}
        </label>

        <label className="block">
          <span className="label-text text-xs font-semibold">Icon</span>
          <input
            className="input input-bordered input-sm w-full mt-1"
            {...register('icon', { required: 'Icon is required' })}
            placeholder="Icon name"
          />
          {errors.icon && <p className="text-error text-xs mt-1">{errors.icon.message}</p>}
        </label>

        <div className="flex gap-2 pt-2">
          <button type="button" className="btn btn-ghost btn-sm flex-1" onClick={() => onCancel()}>
            Cancel
          </button>
          <input className="btn btn-primary btn-sm flex-1" type="submit" value={category ? 'Save' : 'Create'} />
        </div>
      </form>
    </Modal>
  );
};

export default CategoryForm;
